import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insights/empty_state_team_members.svg'


const _withScopeId = n => (_pushScopeId("data-v-bfb258d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "engagement-empty-team-member-state" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Typography, {
      variant: "h4",
      innerHTML: _ctx.headerText
    }, null, 8, ["innerHTML"]),
    _createVNode(_component_Typography, {
      variant: "body2",
      innerHTML: _ctx.bodyText
    }, null, 8, ["innerHTML"])
  ]))
}